import styled from 'styled-components';

export const Wrapper = styled.div`
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  padding: 18px;
  border-radius: 8px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.white};
  box-sizing: border-box;
  transition: outline-width 100ms;
  border: 1px solid ${({ theme }) => theme.colors.black3};

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    width: 50%;
  }
`;

export const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const EmptyWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black5};
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

export const Text = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
  color: ${({ theme }) => theme.colors.black7};
`;

export const Description = styled.div`
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black7};
`;
